module.exports = __webpack_public_path__ + "img/symbol_3.b9283620.png";